var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommiter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    transform: "matrix(1 0 0 -1 0 64.2964)",
    fill: "url(#paint0_linear_957_1944)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_957_1944)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    transform: "matrix(1 0 0 -1 10 74.2964)",
    fill: "#EEEEEE",
    fillOpacity: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 63,
    height: 63,
    rx: 14.5,
    transform: "matrix(1 0 0 -1 10 73.2964)",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8227 34.939C46.3139 32.8198 45.0193 30.6976 42.9311 30.1991C40.8429 29.7005 38.7519 31.0143 38.2606 33.1335C37.7693 35.2527 39.0639 37.3749 41.1521 37.8734C43.2403 38.372 45.3314 37.0582 45.8227 34.939Z",
    stroke: "#E34B4B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0801 34.6616C49.1933 35.9756 51.5448 38.7727 52.2874 42.1785",
    stroke: "#E34B4B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1649 45.5844C33.088 44.6182 35.4205 45.4201 36.3726 47.3718C37.3246 49.3235 36.5344 51.6907 34.6113 52.6569C32.6882 53.623 30.3556 52.8211 29.4036 50.8694C28.4516 48.9129 29.2417 46.5457 31.1649 45.5844Z",
    stroke: "#E34B4B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5787 45.0673C31.5692 44.8741 31.5645 44.6856 31.5645 44.4876C31.5645 41.1108 33.1163 38.0963 35.5392 36.1494",
    stroke: "#E34B4B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4116 52.6764C47.4932 51.6957 46.7268 49.3238 47.6931 47.3769C48.6595 45.43 50.9967 44.6523 52.9151 45.6329C54.8335 46.6136 55.5999 48.9856 54.6335 50.9325C53.6625 52.8793 51.3252 53.6619 49.4116 52.6764Z",
    stroke: "#E34B4B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8302 52.604C47.0023 54.1789 44.6364 55.1306 42.0469 55.1306C40.3855 55.1306 38.8147 54.7393 37.4199 54.0388",
    stroke: "#E34B4B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_957_1944",
    x: 2,
    y: 2.29639,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_957_1944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_957_1944",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_957_1944",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCBCB",
    stopOpacity: 0.34
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommiter);
export default __webpack_public_path__ + "static/media/Commiter.c2252dc1eac3cd79955eb587f20cfa93.svg";
export { ForwardRef as ReactComponent };